import React, { useEffect, useMemo, useState } from 'react';
import { defineMessages } from 'react-intl';
import { useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import useAuth from '@hooks/useAuth';
import useFetch from '@hooks/useFetch';
import useFetchAction from '@hooks/useFetchAction';
import useRestaurant from '@hooks/useRestaurant';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { getCacheX_tenant } from '@services/userService';
import { accountActions } from '@store/actions';

import ProfileForm from './ProfileForm';

const message = defineMessages({
    objectName: 'profile',
});

const ProfilePage = () => {
    const translate = useTranslate();
    const params = useParams();
    const { isAdmin } = useAuth();
    const tenant = getCacheX_tenant();
    const id = useMemo(() => {
        if (tenant) {
            const lastUnderscoreIndex = tenant.lastIndexOf('_');
            const idTenant = tenant.substring(lastUnderscoreIndex + 1);
            return idTenant;
        }
        return null;
    }, [ tenant ]);

    const [ detail, setDetail ] = useState({});
    const { execute, loading } = useFetch(
        useMemo(
            () => (isAdmin() ? apiConfig.account.getProfile : apiConfig.account.getShopAccountProfile),
            [ isAdmin() ],
        ),
        { immediate: false },
    );
    const { execute: executeGetProfile } = useFetchAction(accountActions.getProfile);
    const { mixinFuncs, onSave, setIsChangedFormValues, isEditing } = useSaveBase({
        options: {
            getListUrl: tenant ? `/${id}/menu` : `/restaurants`,
            objectName: translate.formatMessage(message.objectName),
        },
        apiConfig: {
            getById: apiConfig.account.getProfile,
            update: isAdmin() ? apiConfig.account.updateProfileAdmin : apiConfig.account.updateShopAccountProfile,
        },
        override: (funcs) => {
            const onSaveCompleted = funcs.onSaveCompleted;

            funcs.onSaveCompleted = (response) => {
                onSaveCompleted(response);
                executeGetProfile();
            };
        },
    });

    useEffect(() => {
        execute({
            onCompleted: (response) => {
                if (response.result === true) setDetail(response.data);
            },
            onError: mixinFuncs.handleGetDetailError,
        });
    }, []);

    return (
        <PageWrapper loading={loading} routes={[ { breadcrumbName: translate.formatMessage(commonMessage.profile) } ]}>
            <ProfileForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isAdmin={isAdmin}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={onSave}
            />
        </PageWrapper>
    );
};

export default ProfilePage;
